import React from 'react';
import "./sidebar.scss"
import { NavLink } from 'react-router-dom';
import { FaSlack } from 'react-icons/fa';

const Sidebar = () => {
  return (
    <nav className="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
      <div className="position-sticky pt-1">
        <div className="d-flex align-items-center mb-3 px-3">
          <FaSlack size={30} className="me-2" />
          <span className="fw-bold fs-5">Slack Dashboard</span>
        </div>
        <ul className="nav flex-column">
          <li className="nav-item">
            <NavLink
              className="nav-link"
              activeClassName="active"
              to="/slack/dashboard/dashboard"
            >
              Dashboard
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              className="nav-link"
              activeClassName="active"
              to="/slack/dashboard/tasks"
            >
              Tasks
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/slack/dashboard/calendar"
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              Authenticates
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Sidebar;